import {
	Component,
	Input,
	OnInit,
	ChangeDetectionStrategy,
} from "@angular/core"
import { ActivatedRoute } from "@angular/router"
import { COMMON_IMPORTS } from "@app/common-imports"
import { ApiService } from "@app/services/api.service"
import { LangService } from "@app/services/lang.service"
import { LogoutTimerService } from "@app/services/logout-timer.service"
import { ModalService } from "@app/services/modal.service"
import { StoreService } from "@app/services/store.service"
import { TestanswersFillComponent } from "@app/testanswers-fill/testanswers-fill.component"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { BtnExtComponent, SpinOrContent } from "@app/utils/utils.component"

@Component({
	selector: "app-patient-test-fill",
	imports: [
		COMMON_IMPORTS,
		LangValPipe,
		SpinOrContent,
		BtnExtComponent,
		TestanswersFillComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<div class="patient-fill">
			@if (isLoggedOut) {
				<div>{{ "test_time_expired" | langVal }}</div>
			} @else {
				@if (hasLoaded) {
					@if (res?.filled) {
						<div class="patient-fill-message">
							<p>{{ "filled_test_already_sent" | langVal }}</p>
						</div>
					}
					@if (res.user_name) {
						<p class="userName">{{ res.user_name }}</p>
					}
					@if (testDone) {
						<div class="patient-fill-message">
							<app-spin-or-content [isSpin]="isSaving">
								<div class="d-grid gap-2">
									<!--	<p>{{ res.name }},</p>  -->
									<p>{{ "thank_you_for_filling" | langVal }}</p>
								</div>
								@if (id) {
									<app-btn-ext
										text="download_pdf_after_save"
										(clickEv)="download()"
										[isSpin]="isDownloading"
										iconName="download"
									/>
								}
							</app-spin-or-content>
						</div>
					} @else {
						@if (test_id) {
							<app-testanswers-fill
								(onFinish)="testFinish($event)"
								(onSaveState)="handleSaveState($event)"
								[test_id]="test_id"
								[state]="$safeNavigationMigration(res?.state)"
								inUserPatientMode
							/>
						}
					}
				}
			}
		</div>
	`,
})
export class PatientTestFillComponent implements OnInit {
	siteData: any = []
	hasLoaded: boolean = false
	res: any = null
	test_id: any = null
	testDone: boolean = false
	isLoggedOut: boolean = false
	id: any = null
	isSaving: boolean = false
	isDownloading: boolean = false

	@Input() code: string = ""

	constructor(
		private apiService: ApiService,
		protected route: ActivatedRoute,
		public modalService: ModalService,
		public lang: LangService,
		private store: StoreService,
		private logoutTimerService: LogoutTimerService
	) {}

	async ngOnInit() {
		await this.store.timeout(500)
		this.init()
	}
	async init() {
		const res = await this.apiService.post(
			"patient_test_fill_init",
			this,
			"code"
		)
		this.hasLoaded = true
		if (!res) {
			return
		}
		this.res = res
		if (res?.filled) {
			return
		}
		const test_id = res.test_id
		this.siteData = { tests: res.tests, testquestions: res.testquestions }

		sessionStorage.setItem("siteData", JSON.stringify(this.siteData))

		this.logoutTimerService.init(15, () => {
			this.isLoggedOut = true
			sessionStorage.removeItem("siteData")
		})

		if (!this.siteData?.tests?.length || !test_id) {
			console.log(1)
			return
		}
		const test = this.siteData.tests.find((it) => it.id == test_id)
		if (!test) {
			return
		}
		if (test.lang === "en") {
			this.lang.routeTryChangeLang(test.lang)
		}
		this.test_id = test_id
	}
	getTestQuestionsIdAndAnswer(test: any) {
		if (!test?.questions?.length) {
			return []
		}
		return test.questions.map((item) => ({
			id: item.id,
			answer: item.answer,
		}))
	}
	async handleSaveState(test: any) {
		const innerQs = test.tests?.length
			? test.tests.map((t) => this.getTestQuestionsIdAndAnswer(t)).flat()
			: []
		const questions = [...this.getTestQuestionsIdAndAnswer(test), ...innerQs]

		await this.apiService.post("test_save_state", {
			questions,
			code: this.code,
		})
	}

	async testFinish(test: any) {
		if (!test) {
			return
		}
		this.testDone = true
		this.isSaving = true
		const { id } = await this.apiService.post("patient_answer_test", {
			...test,
			code: this.code,
		})
		this.isSaving = false
		this.id = id

		this.modalService.openToast("filled_test_sent")
	}
	download() {
		this.store.downloadToastFunc(async () => {
			const resPdf: any = await this.apiService.download(
				"patient_download_test",
				{ id: this.id, code: this.code }
			)
			if (!resPdf?.size) {
				return this.modalService.openToast("saved_successfully")
			}
			this.apiService.downloadFile(resPdf, this.lang.getVal("test") + ".pdf")
		})
	}
}
